import { DescriptionItem, DescriptionList } from "components";
import { toolTipStyle } from "helper/utils";
import { CurbZoneShorten } from "../hooks/use-curb-zones-layer";

type CurbZonePlaceTypeTooltipProps = {
  left: number;
  top: number;
  curbZone: CurbZoneShorten;
};

export const CurbZonePlaceTypeTooltip = ({ left, top, curbZone }: CurbZonePlaceTypeTooltipProps) => {
  const styles = toolTipStyle({ top, left, height: 90, width: 220 });
  const policyNames = curbZone.curbPolicies?.map((policy) => policy.name).filter(Boolean) ?? [];

  return (
    <div style={styles} className="absolute w-56">
      <div className="relative transition-opacity h-auto p-3 mt-2 mb-3 rounded-md shadow-lg z-10 bg-primary">
        <DescriptionList>
          <DescriptionItem
            label="Type de place"
            value={
              policyNames.length > 0 ? (
                <div className="flex flex-col gap-1">
                  {policyNames.map((name, index) => (
                    <span key={`policy-${index}`}>{name}</span>
                  ))}
                </div>
              ) : undefined
            }
          />
        </DescriptionList>
      </div>
    </div>
  );
};
